import { useShowLal } from '@openx/components-segment/lib/utils/useShowLal';
import type { ListLalSegment, ListSegment } from '@openx/types/segments';
import { useState } from 'react';

import { Navigate, Route, Routes } from 'react-router';
import { SegmentsList } from './components/SegmentsList';
import { SegmentsPageHeader } from './components/SegmentsPageHeader';
import { SegmentsTabs } from './components/SegmentsTabs';
import { useExportSegmentsDialog } from './hooks/useExportSegmentsDialog';
import { LalSegmentsList } from './lal/components/LalSegmentsList';

export const SegmentsListPage = () => {
  const [selectedSegments, setSelectedSegments] = useState<ListSegment[]>([]);
  const [selectedLalSegments, setSelectedLalSegments] = useState<ListLalSegment[]>([]);
  const showLal = useShowLal();
  const {
    open: openExportSegments,
    registerCriteria: registerExportCriteria,
    isExportDisabled,
  } = useExportSegmentsDialog();

  const handleTabChange = () => {
    setSelectedSegments([]);
    setSelectedLalSegments([]);
  };

  return (
    <SegmentsPageHeader
      selectedSegments={selectedSegments}
      setSelectedSegments={setSelectedSegments}
      selectedLalSegments={selectedLalSegments}
      setSelectedLalSegments={setSelectedLalSegments}
      onExportSegments={openExportSegments}
      isExportDisabled={isExportDisabled}
    >
      <SegmentsTabs onTabChange={handleTabChange} />
      <Routes>
        <Route
          path="audience"
          element={
            <SegmentsList
              selectedSegments={selectedSegments}
              setSelectedSegments={setSelectedSegments}
              registerExportCriteria={registerExportCriteria}
            />
          }
        />
        {showLal && (
          <Route
            path="lookalike"
            element={
              <LalSegmentsList selectedSegments={selectedLalSegments} setSelectedSegments={setSelectedLalSegments} />
            }
          />
        )}
        <Route path="*" element={<Navigate to="/segments/audience" replace />} />
      </Routes>
    </SegmentsPageHeader>
  );
};
